export const MERGE_LIMITS = Object.freeze({
  count: 20,
  eachBytes: 50 * 1024 * 1024,
  totalBytes: 100 * 1024 * 1024,
  pages: 500
});

export function validateMergeFile(file) {
  if (!file) return "Choose a PDF to continue.";
  if (file.size > MERGE_LIMITS.eachBytes) return "File exceeds the 50 MB limit.";
  const extension = file.name?.toLowerCase().endsWith(".pdf");
  const mime = (file.type || "").toLowerCase();
  if (!extension && !["application/pdf", "application/octet-stream", ""].includes(mime)) {
    return "Only PDF files are supported.";
  }
  return null;
}

export function hasPdfHeader(bytes) {
  if (!bytes || bytes.length < 5) return false;
  return String.fromCharCode(...bytes.slice(0, 5)) === "%PDF-";
}

export function validateMergeCollection(existing, incoming) {
  if (existing.length + incoming.length > MERGE_LIMITS.count) {
    return `A maximum of ${MERGE_LIMITS.count} PDFs is allowed.`;
  }
  const total = [...existing, ...incoming].reduce((sum, item) => sum + Number(item.size || 0), 0);
  if (total > MERGE_LIMITS.totalBytes) return "The selected PDFs exceed the 100 MB combined limit.";
  return null;
}

export function validateMergedPageCount(currentPages, incomingPages) {
  if (!Number.isInteger(incomingPages) || incomingPages < 1) return "This PDF does not contain any pages.";
  if (currentPages + incomingPages > MERGE_LIMITS.pages) {
    return `The selected PDFs exceed the ${MERGE_LIMITS.pages} page combined limit.`;
  }
  return null;
}

export function moveMergeItem(items, fromIndex, toIndex) {
  if (fromIndex < 0 || fromIndex >= items.length || toIndex < 0 || toIndex >= items.length || fromIndex === toIndex) return [...items];
  const next = [...items];
  const [item] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, item);
  return next;
}

export function normalizeMergedName(value) {
  const clean = (value || "").trim().replace(/[\\/:*?"<>|]+/g, "-");
  if (!clean) return "merged.pdf";
  return clean.toLowerCase().endsWith(".pdf") ? clean : `${clean}.pdf`;
}
